import { Component, Input } from '@angular/core';
import { ErrorService } from '@app/services';
import { EntityTableComponent } from '@app/abstracts';
import { PointOfInterestSearchParams } from '../point-of-interest-search-params';
import { PointOfInterestService } from '../point-of-interest.service';
import { PointOfInterest } from '../point-of-interest';

@Component({
	selector: 'hpf-point-of-interest-table',
	templateUrl: './point-of-interest-table.component.html',
})
export class PointOfInterestTableComponent extends EntityTableComponent<
	PointOfInterest,
	PointOfInterestSearchParams
> {
	/** Columns to show */
	@Input() columns = ['created_at', 'name', 'url', 'published', 'deleted'];
	/** Constructor */
	constructor(
		private pointOfInterestService: PointOfInterestService,
		private errorService: ErrorService
	) {
		super();
	}
	/** @inheritDoc */
	protected refresh(): void {
		const params = this.searchParams.toObject();
		params._populate = [
			'thumbnail',
			'title.lang',
			'categories.title.lang',
			'plateau.title.lang',
		];
		// Set refreshing flag
		this.refreshing = true;
		// Get list
		this.pointOfInterestService
			.list(params)
			.then((results) => {
				// Link data
				this.items = results.items;
				this.total = results.total;
			})
			.catch((error) => this.errorService.handle(error))
			.then(() => {
				this.refreshing = false;
			});
	}

	/** Called when the user select multiple rows and delete them */
	async removeMany() {
		if (!this.selectedRows.length) {
			return;
		}

		this.deleting = true;
		for (const item of this.selectedRows) {
			await this.pointOfInterestService
				.remove(item.getId())
				.catch((e) => this.errorService.handle(e));
		}

		this.deleteMany.next(this.selectedRows);
		this.resetSelectedRows();
		this.deleting = false;
		this.deleteManyModal = false;
		this.searchParams.next();
	}
	/** Called when the user delete a single row */
	async removeOne() {
		if (!this.rowToDelete) {
			return;
		}

		this.deleting = true;
		await this.pointOfInterestService
			.remove(this.rowToDelete.getId())
			.catch((e) => this.errorService.handle(e));

		this.deleteOne.next(this.rowToDelete);
		delete this.rowToDelete;
		this.deleting = false;
		this.deleteOneModal = false;
		this.searchParams.next();
	}
}
